import React from 'react'
import ChatLayout from '../Components/Chat/Chatlayout';
const ChatPage = () => {
  return (
   <ChatLayout />
  )
}

export default ChatPage